import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function toArray(input) {
  if (!input) return [];
  if (Array.isArray(input)) return input.map(String).map((s) => s.trim()).filter(Boolean);
  return String(input)
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export default function ImageCarousel({
  sources,
  alt,
  className,
  imageClassName,
  placeholder = "/placeholder.svg",
  showCount = true,
  paginationId,
}) {
  const urls = toArray(sources);
  const count = urls.length;
  const [, setIndex] = React.useState(0);

  React.useEffect(() => {
    setIndex(0);
  }, [sources]);

  if (count === 0) {
    return (
      <div className={"relative select-none " + (className || "") }>
        <img alt={alt} src={placeholder} className={"w-full h-full object-contain " + (imageClassName || "")} loading="lazy" />
        {showCount && (
          <div className="absolute bottom-2 right-2 rounded-md bg-black/60 text-white text-xs px-2 py-1">0 / 0</div>
        )}
      </div>
    );
  }

  const paginationConfig = paginationId
    ? { el: `#${paginationId}`, clickable: true, renderBullet: (i, cn) => `<span class="${cn}">${i + 1}</span>` }
    : { clickable: true, renderBullet: (i, cn) => `<span class="${cn}">${i + 1}</span>` };

  return (
    <div className={"select-none ecat-swiper " + (className || "") }>
      <Swiper
        className="w-full h-full"
        modules={[Pagination, A11y]}
        slidesPerView={1}
        spaceBetween={8}
        allowTouchMove={true}
        pagination={paginationConfig}
        onSlideChange={(sw) => setIndex(sw.realIndex)}
      >
        {urls.map((u, i) => (
          <SwiperSlide key={i} className="w-full h-full">
            <div className="w-full h-full flex items-center justify-center">
              <img
                alt={alt}
                src={u}
                className={(imageClassName ? imageClassName + " " : "") + "max-h-full max-w-full h-full w-auto object-contain"}
                loading="lazy"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}


